import { render, staticRenderFns } from "./EstadisticasCliente.vue?vue&type=template&id=18cefa07&scoped=true&lang=pug"
import script from "./EstadisticasCliente.vue?vue&type=script&lang=js"
export * from "./EstadisticasCliente.vue?vue&type=script&lang=js"
import style0 from "./EstadisticasCliente.vue?vue&type=style&index=0&id=18cefa07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cefa07",
  null
  
)

export default component.exports